import { useCallback, useEffect, useState } from 'react';
import { meAPI, ManualInfo } from '../services/api';

/**
 * Υπάρχει εγχειρίδιο για τον οργανισμό του καταστήματος; (για να εμφανιστεί η
 * επιλογή στο μενού). Κοινή μνήμη σε επίπεδο module: το Navigation ξαναστήνεται
 * σε κάθε αλλαγή σελίδας και δεν χρειάζεται νέα κλήση κάθε φορά.
 *
 * Η ΛΗΨΗ φέρνει πάντα την τελευταία έκδοση από τον server — η μνήμη αφορά μόνο
 * το αν φαίνεται η επιλογή και την ημερομηνία που γράφει.
 */
const TTL_MS = 10 * 60 * 1000;
let cache: { key: string; at: number; info: ManualInfo | null } | null = null;

export function useManualInfo(storeId: number | undefined, enabled: boolean) {
  const key = enabled && storeId ? String(storeId) : '';
  const [info, setInfo] = useState<ManualInfo | null>(() => (cache && cache.key === key ? cache.info : null));

  const refresh = useCallback((force = false) => {
    if (!key) { setInfo(null); return; }
    if (!force && cache && cache.key === key && Date.now() - cache.at < TTL_MS) {
      setInfo(cache.info);
      return;
    }
    meAPI.getManual()
      .then(r => {
        cache = { key, at: Date.now(), info: r.manual || null };
        setInfo(cache.info);
      })
      .catch(() => { /* χωρίς πληροφορία απλώς δεν φαίνεται η επιλογή */ });
  }, [key]);

  useEffect(() => { refresh(); }, [refresh]);

  return { manual: info, refresh };
}
